import React from "react";
import { ScopeSelect } from "./ScopeSelect";
import { Users, Layers, X, UserCheck } from "lucide-react";
import { TEAMS } from "../data/constants";

export const teamLabel = (id, zh) => { const t = TEAMS.find((x) => x.id === id); return t ? (zh ? t.zh : t.name) : id; };

/* 线上项目经理工作台头部：项目范围 + 负责工程组 + 按阶段一键筛选 */
export const CdcTeamBar = ({ data, zh, team, onTeam, phase, onPhase, scope = "all", onScope }) => {
  const T = (a, b) => (zh ? a : b);
  const bound = data.teamBound;
  return (
    <div className="rounded-2xl border border-violet-200 bg-violet-50/40 px-4 py-3 space-y-2.5" data-testid="cdc-team-bar">
      {/* 走查清单三-4（视频 10:26–13:07 / 12:14–12:54）：项目范围筛选。
          PM / 线上 PM 平时只关心「自己负责的项目」，管理层则要看全部；两者都要，故做成可切换的开关。
          「只看我负责」由后端按 co_staff（主办 PM / 线上 PM / 协办）判定范围。 */}
      <div className="flex flex-wrap items-center gap-1.5" data-testid="cdc-scope-filter">
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-600" data-testid="cdc-scope-label">
          <UserCheck className="h-3.5 w-3.5" />{T("项目范围", "Project scope")}
        </span>
        <button type="button" data-testid="cdc-scope-all" onClick={() => onScope && onScope("all")}
          className={`text-[11px] rounded-full px-2.5 py-1 font-semibold ${scope !== "mine" ? "bg-violet-600 text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-violet-300"}`}>{T("全部项目", "All projects")}</button>
        <button type="button" data-testid="cdc-scope-mine" onClick={() => onScope && onScope("mine")}
          className={`text-[11px] rounded-full px-2.5 py-1 font-semibold ${scope === "mine" ? "bg-violet-600 text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-violet-300"}`}>{T("只看我负责", "Only mine")}</button>
      </div>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="inline-flex items-center gap-1.5 font-bold text-violet-900" data-testid="cdc-team-badge" data-team={data.team || "all"}>
          <Users className="h-4 w-4 text-violet-600" />
          {T("负责工程组：", "Construction team: ")}
          <span className="px-2 py-0.5 rounded-full bg-violet-600 text-white">{data.team ? teamLabel(data.team, zh) : T("全部工程组", "All teams")}</span>
          <span className="text-slate-500 font-normal">· {data.projects} {T("个在建项目", "active projects")}</span>
        </span>
        {bound ? (
          <span className="text-[11px] text-slate-500" data-testid="cdc-team-bound-hint">{T("（账号已绑定该组，仅显示该组工程项目）", "(bound to this team by account settings)")}</span>
        ) : (
          <ScopeSelect kind="team" data-testid="cdc-team-select" value={team} onChange={(e) => onTeam(e.target.value)} className="ml-auto h-7 rounded-md border border-violet-200 bg-white px-2 text-xs">
            <option value="">{T("全部工程组", "All teams")}</option>
            {TEAMS.map((t) => <option key={t.id} value={t.id}>{zh ? t.zh : t.name}</option>)}
          </ScopeSelect>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-1.5" data-testid="cdc-phase-filter">
        <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-600"><Layers className="h-3.5 w-3.5" />{T("按阶段筛选", "Filter by phase")}</span>
        <button type="button" data-testid="cdc-phase-all" onClick={() => onPhase(null)}
          className={`text-[11px] rounded-full px-2.5 py-1 font-semibold ${phase == null ? "bg-brand-grad text-white shadow-brand" : "bg-white border border-slate-200 text-slate-600 hover:border-violet-300"}`}>{T("全部", "All")}</button>
        {(data.phases || []).map((p) => (
          <button key={p.phaseIdx} type="button" data-testid={`cdc-phase-chip-${p.phaseIdx}`} data-count={p.items} onClick={() => onPhase(phase === p.phaseIdx ? null : p.phaseIdx)}
            className={`text-[11px] rounded-full px-2.5 py-1 font-semibold inline-flex items-center gap-1 ${phase === p.phaseIdx ? "bg-violet-600 text-white" : "bg-white border border-slate-200 text-slate-700 hover:border-violet-300"}`}>
            {p.phase}<span className={`${phase === p.phaseIdx ? "text-violet-200" : "text-slate-400"} font-normal`}>{p.projects}{T("项目", "p")} · {p.items}{T("待办", "todo")}</span>
          </button>
        ))}
        {phase != null && <button type="button" data-testid="cdc-phase-clear" onClick={() => onPhase(null)} className="inline-flex items-center gap-0.5 text-[11px] text-slate-500 hover:text-slate-800"><X className="h-3 w-3" />{T("清除", "Clear")}</button>}
      </div>
    </div>
  );
};
